<template>
  <v-app id="login" class="primary" color="red">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 md3>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img :src="logo" alt="Segworks Technologies" width="180" height="180">
                  <h2 style="color:red" class="flex my-4 primary--text">Eclaims CF4 Generator</h2>
                </div>
                <v-form>
                  <v-text-field
                    append-icon="person"
                    name="login"
                    label="Email"
                    type="email"
                    v-model="userEmail"
                    :error="error"
                    :rules="[rules.required , rules.email]"/>
                  <v-text-field
                    :type="hidePassword ? 'password' : 'text'"
                    :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                    name="password"
                    label="Password"
                    id="password"
                    :rules="[rules.required]"
                    v-model="password"
                    :error="error"
                    @click:append="hidePassword = !hidePassword"/>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block dark color="rgb(41, 41, 97)" @click="login" :loading="loading">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-snackbar
        v-model="showResult"
        :timeout="2000"
        top>
        {{ result }}
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                userEmail: '',
                password: '',
                hidePassword: true,
                error: false,
                showResult: false,
                result: '',
                rules: {
                    required: value => !!value || 'Required.',
                    email: value => this.validEmail(value) || 'Must be a valid Email.'
                }
            }
        },

        methods: {
            login() {
                const vm = this;

                if (!vm.userEmail || !vm.password) {
                    vm.result = "Email and Password can't be null.";
                    vm.showResult = true;
                    return;
                }

                this.axios.post('login', {
                        'username': vm.userEmail,
                        'password': vm.password
                    }
                ).then((response) => {
                    if (response.data.success) {
                        localStorage.setItem('AUTH_TOKEN', response.data.token.token);
                        localStorage.setItem('AUTH_USER', response.data.token.user);
                        this.$router.push({path: '/'})
                    } else {
                        this.$snotify.error("Invalid Credentials", 'Oops!');
                    }
                }).catch((error) => {
                    vm.result = error;
                    console.error(error.toString());
                });
            },
            validEmail: function (email) {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            }
        },
        computed: {
            logo() {
                return require('@/assets/segworks.png')
            }
        }
    }
</script>

<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgb(41, 41, 97) !important;
    content: "";
    z-index: 0;
  }

</style>
